<template>
  <div
    :class="
      twMerge(
        'max-w-screen-xl mt-20 md:mt-24 mb-10 md:mb-12 mx-auto px-4',
        $attrs.class
      )
    "
  >
    <Heading
      h-class="text-h4"
      :level="2"
      :title="content.title"
      :use-h-tag="false"
      class="mb-2 mb-md-4 kft-product-showcase__heading kft-heading--left"
    />
    <div class="grid grid-cols-2 md:grid-cols-3 mt-8 gap-6">
      <div v-for="(item, index) in content.items" :key="`tab-links-${index}`">
        <NuxtLink
          :to="localePath(item.link)"
          class="underline mb-5 hover:no-underline"
        >
          {{ item.label }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

const { content = {} } = defineProps<{ content: any }>()
const $localePath = useLocalePath()
const localePath = $localePath
</script>
<style lang="postcss" scoped></style>
